import useTranslation from '../../../../features/translation/hooks/useTranslation';
import { RequestHandler } from '../../../../app/RequestHandler';
import { LinkButton } from '@festo-ui/react';
import { econdaClickEvent } from '../../../../Econda';
import { useLocation } from 'react-router-dom';

enum TranslationKeys {
  LOGIN = 'resultLogin',
}

const LoginLink = () => {
  const t = useTranslation();
  const { language, country } = new RequestHandler();
  const { pathname } = useLocation();

  const handleLogin = () => {
    econdaClickEvent(pathname, 'text link', 'please login for pricing', 'click');
    window.location.href = `${process.env.REACT_APP_FESTO_URL}${country}/${language}/login/`;
  };

  return (
    <LinkButton className="fwe-mr-3" icon="file-secure" onClick={handleLogin}>
      {t(TranslationKeys.LOGIN)}
    </LinkButton>
  );
};

export default LoginLink;
